import { PortableText } from "@portabletext/react";
import urlBuilder from "@sanity/image-url";
import { getImageDimensions } from "@sanity/asset-utils";
import { urlFor } from "../../../../lib/sanity";

export default function PostImage({ value, isInline }) {
    if (!value.hasOwnProperty("asset")) return null;
    const { width, height } = getImageDimensions(value);
    return (
        <figure className="my-8">
            <img
                src={urlFor(value)
                    .width(isInline ? 100 : 1200)
                    .fit("max")
                    .auto("format")
                    .url()}
                alt={value.alt || " "}
                loading="lazy"
                style={{
                    // Display alongside text if image appears inside a block text span
                    display: isInline ? "inline-block" : "block",

                    // Avoid jumping around with aspect-ratio CSS property
                    aspectRatio: width + "/" + height,
                }}
            />
            <figcaption className="text-sm text-gray-500 mt-1">
                {value.caption}
            </figcaption>
        </figure>
    );
}
